import React, { useEffect, useState } from 'react';
import { MapPinIcon } from 'lucide-react';
export function Story() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const images = [{
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/r7gfmMHTNUZWLcXoSC3HX4/Generated_Image_October_21%2C_2025_-_3_58PM.png',
    alt: 'Gabriel Beltrán con premios'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oP1eG24kCnTAFFe1n2PXrJ/WhatsApp_Image_2025-09-18_at_12.09.17.jpg',
    alt: 'Gabriel Beltrán presentando'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/do9dz9VDHz4ngj5jfV7F8A/WhatsApp_Image_2025-09-18_at_12.09.17_%281%29.jpg',
    alt: 'Gabriel Beltrán en evento'
  }];
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % images.length);
    }, 2000);
    return () => clearInterval(interval);
  }, [images.length]);
  return <section className="w-full px-4 py-16 md:py-20" data-id="element-318">
      <div className="max-w-4xl mx-auto" data-id="element-319">
        <div className="bg-slate-800/50 border border-slate-700 rounded-2xl p-6 md:p-10" data-id="element-320">
          <div className="mb-8" data-id="element-321">
            <p className="text-base md:text-lg text-gray-400 mb-2" data-id="element-322">
              De:{' '}
              <span className="text-white font-semibold" data-id="element-323">Gabriel Beltrán</span>
            </p>
            <div className="flex items-center gap-2 text-gray-400 mb-4" data-id="element-324">
              <MapPinIcon className="w-4 h-4" data-id="element-325" />
              <p className="text-sm md:text-base" data-id="element-326">Miami, FL</p>
            </div>
            <div className="bg-purple-500/10 border border-purple-500/30 rounded-lg p-4" data-id="element-327">
              <p className="text-sm md:text-base text-gray-300 leading-relaxed" data-id="element-328">
                Emprendedor con 10+ años de experiencia •{' '}
                <span className="text-purple-400 font-semibold" data-id="element-329">
                  +$50 millones generados online
                </span>{' '}
                • Mentor y speaker
              </p>
            </div>
          </div>
          <div className="mb-8" data-id="element-330">
            <div className="relative rounded-xl overflow-hidden aspect-square" data-id="element-331">
              <div className="flex transition-transform duration-500 ease-in-out h-full" style={{
              transform: `translateX(-${currentSlide * 100}%)`
            }} data-id="element-332">
                {images.map((image, index) => <div key={index} className="min-w-full h-full" data-id="element-333">
                    <img src={image.src} alt={image.alt} className="w-full h-full object-cover" data-id="element-334" />
                  </div>)}
              </div>
            </div>
            <div className="flex justify-center gap-2 mt-4" data-id="element-335">
              {images.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-2 h-2 rounded-full transition-all ${currentSlide === index ? 'bg-purple-400 w-8' : 'bg-gray-600 hover:bg-gray-500'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-336" />)}
            </div>
          </div>
          <div className="space-y-6 text-base md:text-lg text-gray-300" data-id="element-337">
            <p data-id="element-338">Cuando comencé a experimentar con IA, vi algo claro:</p>
            <p data-id="element-339">
              Mis amigos pasaban{' '}
              <span className="text-white font-semibold" data-id="element-340">días</span> editando… y
              yo, <span className="text-purple-400 font-semibold" data-id="element-341">minutos</span>
              .
            </p>
            <p className="text-lg md:text-xl font-semibold text-white" data-id="element-342">
              El problema era otro:
            </p>
            <div className="bg-slate-700/50 p-6 rounded-lg" data-id="element-343">
              <ul className="space-y-2 list-disc list-inside text-sm md:text-base" data-id="element-344">
                <li data-id="element-345">No sabían qué herramientas usar</li>
                <li data-id="element-346">Ni cómo conectarlas</li>
                <li data-id="element-347">Ni qué prompts generaban resultados virales</li>
              </ul>
            </div>
            <p data-id="element-348">Así que construí un sistema paso a paso, plug & play.</p>
            <p className="text-lg md:text-xl text-purple-400 font-semibold" data-id="element-349">
              Conecté: ChatGPT → ? → ? → ? → Publicación.
            </p>
            <p data-id="element-350">Resultado: videos listos para viralizarse en 60 minutos.</p>
            <p className="text-lg md:text-xl font-semibold text-white" data-id="element-351">
              Hoy, cientos de creadores lo usan para crecer más rápido, vender
              más y volver a disfrutar crear.
            </p>
          </div>
        </div>
      </div>
    </section>;
}